module.exports = __webpack_public_path__ + "img/checkbox.3fd2aa6d.svg";